import { render } from "./CatalogoAxum.vue?vue&type=template&id=44438587&scoped=true"
import script from "./CatalogoAxum.vue?vue&type=script&lang=js"
export * from "./CatalogoAxum.vue?vue&type=script&lang=js"

import "./CatalogoAxum.vue?vue&type=style&index=0&id=44438587&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44438587"]])

export default __exports__